<template>
	<el-dialog :title='title' :visible.sync="dialogVisible" width="30%" :before-close='close'
		:close-on-click-modal='false'>
		<el-form ref='refwhiteForm' :model="whiteForm" label-position="right" label-width="120px">
			<el-form-item label="公司名称" required>
				<el-select  v-model="whiteForm.company_id"  filterable clearable >
				<el-option v-for="item in companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="姓名" required>
				<el-input v-model="whiteForm.fullname" placeholder="请输入姓名" class="item-name" clearable>
				</el-input>
			</el-form-item>
			<el-form-item label="身份证" required>
				<el-input v-model="whiteForm.idcard" maxlength="18" placeholder="请输入身份证" class="item-id_number"
					clearable></el-input>
			</el-form-item>

			<el-form-item>
				<el-button type='primary' @click="addWhiteList">添加白名单</el-button>
			</el-form-item>
		</el-form>
	</el-dialog>
</template>

<script>
	import {regular} from '@/utils/utils.js'
	export default {
		props:['title'],
		components: {
			
		},
		data() {
			return {
				dialogVisible: false,
				whiteForm: {
					fullname: '',
					idcard: '',
					company_id:''
				},
				companyList:[]
			}
		},
		
		methods: {
			async	getUserCompanyList (){
					let result = await this.$api.getUserCompanyList()
					this.companyList = result
				},
			open() {
				this.getUserCompanyList()
				this.dialogVisible = true
			},
			close(done) {
				this.resetForm()
				this.$emit('refresh')
				done && done()
				this.dialogVisible = false
			},

			/* 校验规则 */
			checkWhiteList() {
				
			},
			async addWhiteList() {
				for (let key in this.whiteForm) {
					if(!this.whiteForm[key]){
						this.$message({
							message: `请填写必填项`,
							type: 'warning'
						});
						return
					}
					console.log(regular.IDCard.test(this.whiteForm.idcard))
					if(!regular.IDCard.test(this.whiteForm.idcard)){
						this.$message({
							message: `身份证格式不正确`,
							type: 'warning'
						});
						return
					}
					
				}
				let res = await this.$api.postCompany_djg_userList(this.whiteForm)
				if (res) {
					this.$message({
						message: `添加成功`,
						type: 'success'
					});
					this.close()
				}
			},
		
			//重置表单
			resetForm() {
				this.whiteForm = {
					fullname: '',
					idcard: '',
				}
			},
		},
		
		mounted() {
			
		},
	}
</script>

<style lang="scss" scoped>
	.el-select{
		display: block;
	}
</style>
